import { Fragment, h } from "preact";
import { observer } from "mobx-react";
import { FulfillmentSettingsTracking, } from "restaumatic-client";
import { t, translate } from "../../I18n";
import PreactModal from "../../components/PreactModal";
import LocateMeButton from "../../components/LocateMeButton";
import StreetAddressForm from "../../components/StreetAddressForm";
import Alert from "../../components/Alert";
function FulfillmentAddressModal(props) {
    const { isOpen, controller, geolocation, onSubmit, onShown, onHidden } = props;
    const { validationStatus } = controller;
    const isLoading = validationStatus.type === "Loading" ||
        geolocation.status.type === "Loading";
    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit();
        FulfillmentSettingsTracking.chooseAddressEvent("Menu");
    };
    return (h(PreactModal, { id: "fulfillment-address", isOpen: isOpen, onShown: onShown, onHidden: onHidden },
        h("form", { id: "fulfillment-address-form-modal", onSubmit: handleSubmit },
            h("div", { class: "modal-header" },
                h("button", { type: "button", "data-bs-dismiss": "modal", class: "close", "aria-label": translate(t.generic.close) },
                    h("span", { "aria-hidden": "true", class: "icon-cancel" })),
                h("h4", { class: "modal-title" }, translate(t.order.delivery_address))),
            h("div", { class: "modal-body" },
                h(FromFields, { controller: controller, geolocation: geolocation })),
            h("div", { class: "modal-footer modal-footer--sticky" },
                h("button", { type: "submit", form: "fulfillment-address-form-modal", class: "btn btn-primary btn-block", disabled: isLoading }, isLoading ? (h("span", { class: "icon-spinner icon-spin" })) : (translate(t.actions.save)))))));
}
// FIXME: DRY with DeliveryAddressForm
function FromFields(props) {
    const { controller, geolocation } = props;
    const showLocateMeButton = !(window.Skubacz.Device.isMobileApp() &&
        !window.Skubacz.Device.mobileGeolocationEnabled());
    const isGeolocationLoading = geolocation.status.type === "Loading";
    const handleLocateMe = () => {
        geolocation.locateMe().then(() => {
            // TODO: DRY
            if (geolocation.status.type === "Success") {
                const { fields } = controller;
                const { streetAddress } = geolocation.status;
                fields.city.change(streetAddress.city);
                fields.street.change(streetAddress.street);
                fields.streetNumber.change(streetAddress.streetNumber);
            }
        });
    };
    return (h(Fragment, null,
        showLocateMeButton && (h(Fragment, null,
            h(LocateMeButton, { onLocateMe: handleLocateMe, isLoading: isGeolocationLoading, geolocationError: geolocation.error }))),
        h("div", { class: "m-delivery-address__container" },
            h(StreetAddressForm, { fieldId: "fulfillmentMethod.deliveryAddress", controller: controller })),
        h("div", { class: "m-delivery-address__status" },
            h(AddressStatus, { state: controller.validationStatus }))));
}
function AddressStatus(props) {
    const { state } = props;
    switch (state.type) {
        case "NetworkError":
            return (h(Alert, { type: "danger", message: translate(t.errors.messages.network) }));
        case "AddressDoesNotExistOrInaccurate":
            return (h(Alert, { type: "danger", message: translate(t.delivery.geocoding_error) }));
        default:
            return null;
    }
}
export default observer(FulfillmentAddressModal);
